import { AxiosInstance } from 'axios';
import config from 'config/Config';
import { initAxios } from 'utils/axios';
import { ProjectCommentMentionsData } from 'utils/customTypes';

class ProjectCommentsAPI {
  instance: AxiosInstance;
  constructor() {
    this.instance = initAxios(config.get('backendURL'));
  }

  fetchProjectComments: (projectId: string) => Promise<any> = async (
    projectId
  ) => {
    const { data } = await this.instance.get(
      `project/comment/${projectId}/all`
    );
    return data.data;
  };

  addNewProjectComment: (
    projectId: string,
    userId: string,
    content: string,
    data: { mentions: ProjectCommentMentionsData }
  ) => Promise<any> = async (projectId, commentCreatorId, content, data) => {
    const response = await this.instance.post('project/comment', {
      commentCreatorId,
      projectId,
      content,
      data,
    });
    return response.data.data;
  };

  updateProjectComment: (
    commentId: string,
    content: string,
    data: { mentions: ProjectCommentMentionsData }
  ) => Promise<any> = async (commentId, content, data) => {
    const response = await this.instance.put(`project/comment/${commentId}`, {
      updateFields: { content, data },
    });
    return response.data.data;
  };

  removeProjectComment: (commentId: string) => Promise<any> = async (
    commentId
  ) => {
    await this.instance.delete(`project/comment/${commentId}`);
  };
}

const projectCommentsAPI = new ProjectCommentsAPI();

export default projectCommentsAPI;
